module.exports = __webpack_public_path__ + "img/106.2d543859.png";